import { useCallback, useEffect, useState } from 'react';
import employeesApi from 'Api/axios/employees-api';
import type { EmployeeProfileI } from 'types';

/**
 * Ficha del empleado que se está viendo.
 *
 * Sustituye a `useUser`, que devolvía un arreglo posicional. Había dos
 * productores de ese arreglo con formatos distintos —el listado de empleados y
 * `mapEmployee`— y un solo consumidor, así que entrar por un camino pintaba la
 * terminal en la fila del tipo de usuario. Con un objeto, ese error no se puede
 * escribir.
 */
const useEmployeeProfile = (employeeId?: string) => {
  const [profile, setProfile] = useState<EmployeeProfileI | null>(null);
  const [loading, setLoading] = useState(Boolean(employeeId));
  const [error, setError] = useState<string | null>(null);

  const fetch = useCallback(async () => {
    if (!employeeId) return;

    setLoading(true);
    const response = await employeesApi.readProfile(employeeId);

    if (response.error) {
      setError(response.error);
      setProfile(null);
    } else {
      setError(null);
      setProfile(response.data ?? null);
    }

    setLoading(false);
  }, [employeeId]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { profile, loading, error, refetch: fetch };
};

export default useEmployeeProfile;
